import styled from '@emotion/styled';
import {TextArea} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const TextInputLong = styled(TextArea)`
    margin-bottom: 0.5rem;
    justify-content: center;
    align-self: center;
    align-items: stretch;
`;
